import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  Input,
  OnInit,
  Output,
  EventEmitter,
  QueryList
} from '@angular/core';
import {TabComponent} from "./tab/tab.component";
import * as _ from 'lodash';

@Component({
  selector: 'app-section-tab',
  templateUrl: './section-tab.component.html',
  styleUrls: ['./section-tab.component.scss'],
})
export class SectionTabComponent implements  OnInit, AfterViewInit {

  @Input() defaultSelection: string;

  @ContentChildren(TabComponent) tabs: QueryList<TabComponent>;
  @Output() onSelectTab = new EventEmitter<{ index: number, sectionId: string }>();

  constructor(private changeDetectorRef: ChangeDetectorRef) {
  }

  ngOnInit() {

  }

  selectTab(tab: TabComponent, index: number) {

    //disattivo tutti i tab
    this.tabs.toArray().forEach(tab => tab.active = false);

    var sectionId = tab.sectionId;
    this.onSelectTab.emit({index, sectionId});
    tab.active = true;

  }

  ngAfterViewInit(): void {

    if (this.defaultSelection) {

      _.forEach(this.tabs.toArray(), (tab: TabComponent, index) => {
        if (tab.sectionId == this.defaultSelection) {
          tab.active = true;
          this.onSelectTab.emit({index, sectionId: tab.sectionId});
        }
      });

    }

    this.changeDetectorRef.detectChanges();
  }

}

